<div class="card-content"> 
    <mat-card appearance="outlined" class="card-model">
        <mat-card-header>
            <mat-card-title>
                <div class="title-card">
                    <span>Consulta Objeto</span>
                    <div fxFlex></div>
                    <button mat-mini-fab color="primary" matTooltip="Consultar Preço" (click)="consultar()" >
                        <mat-icon>search</mat-icon>
                    </button>
                </div>
            </mat-card-title>
        </mat-card-header>
        <mat-card-content>
            <div class="cep">
                <div class="cep-content">
                    <div class="cep-fields-grid">
                        <div class="columns-data">
                            <mat-form-field appearance="outline" [formGroup]="formValidation" class="no-padding-form-field cep-font" >
                                <mat-label>Nro. Objeto</mat-label>
                                <input  matInput formControlName="tracking" placeholder="Nro. Objeto"   #inp type = "text"> 
                            </mat-form-field>
                        </div>
                    </div>
                </div>
                <div class="resultado"> 
                    <ul>
                        <li *ngFor="let item of mensagemObj; let i = index"  cdkOverlayOrigin #trigger="cdkOverlayOrigin"   (mouseover)="item.hover=true" (mouseout)="item.hover=false">
                            <div class="li-data" [ngStyle]="{'background-color': i%2 == 0? 'whitesmoke':'none'}" >
                                <span class="key-class">{{item.data}} - {{item.hora}}</span><span class="value-class"> - {{item.descricao}}</span>
                            </div>

                            <ng-template
                            cdkConnectedOverlay
                            [cdkConnectedOverlayOrigin]="trigger"
                            [cdkConnectedOverlayOpen]="item.hover"
                            [cdkConnectedOverlayPositions]="positionPairs"
                            [cdkConnectedOverlayDisableClose]="true"
                            >
                                <div class="overlay-frame mat-elevation-z3">
                                    <div class="linepar"><div class="name">Tipo:</div><div class="edit">{{item.tipo}}</div></div>
                                    <div class="lineimp"><div class="name">Status:</div><div class="edit">{{item.status}}</div></div>
                                    <div class="linepar"><div class="name">Data/Hora:</div><div class="edit">{{item.data}} - {{item.hora}}</div></div>
                                    <div class="lineimp"><div class="name">Local:</div><div class="edit">{{item.cidade}} - {{item.uf}}</div></div>
                                    <div class="linepar"><div class="name">Descrição:</div><div class="edit">{{item.descricao}}</div></div>
                                </div>
                            </ng-template>
                        </li>
                    </ul>
                </div>
            </div>
        </mat-card-content>
    </mat-card>
</div>